import styled from "styled-components";

export const CardContainer = styled.div`
  padding: 0;
  max-width: 350px;
  overflow: hidden;
  font-family: 'Titillium Web', Arial, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 50px;
`;

export const CardHeader = styled.div`
  width: 100%;
  position: relative;
`;

export const PlayerImage = styled.img`
  width: 100%;
  height: 183px;
  object-fit: cover;
  border-radius: 0;
  display: block;
`;

export const CategoryLabel = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  background: #fff;
  color: #022142;
  font-weight: 700;
  font-size: 15px;
  padding: 4px 12px 4px 32px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  z-index: 2;
  min-height: 28px;
`;

export const CategoryIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  position: absolute;
  left: 8px;
  top: 4px;
`;

export const PlayerInfo = styled.div`
  padding: 18px 18px 0 18px;
`;

export const PlayerName = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #444;
  margin: 0 0 6px 0;
`;

export const PlayerMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 1px;
  color: #888;
  font-size: 16px;
  margin-bottom: 8px;
`;

export const ReportText = styled.p`
  color: #444;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 18px 18px 18px;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: end;
  align-items: start;
  color: #666;
  font-size: 14px;
  padding: 12px 18px 0 18px;
  margin-top: auto;
`;

export const ReadMore = styled.a`
  color: #022142;
  font-weight: 700;
  text-decoration: none;
  margin-left: auto;
  font-size: 16px;
  transition: color 0.2s;
  &:hover {
    color: #0077b6;
    text-decoration: underline;
  }
`;
